import React, { useState } from 'react';
import styled from 'styled-components';

const InputContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin-top: 16px;
`;

const InputField = styled.input`
    width: 100%;
    padding: 16px;
    font-size: 1rem;
    border: 2px solid var(--border-color);
    border-radius: 8px;
    background-color: var(--tile-empty);
    color: var(--text-color);
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    cursor: text; /* Indicate that the field is clickable */

    &:focus {
        border-color: var(--accent-color);
        box-shadow: 0 0 0 4px rgba(83, 141, 78, 0.2);
    }

    &::placeholder {
        color: var(--border-color);
    }
`;

const SubmitButton = styled.button`
    width: 100%;
    padding: 16px;
    font-size: 1rem;
    font-weight: bold;
    margin-top: 12px;
    background-color: var(--accent-color);
    color: var(--text-color);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #6aaa64;
    }

    &:disabled {
        background-color: var(--border-color);
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

interface GuessInputProps {
    onSubmit: (guess: string) => void;
}

const GuessInput: React.FC<GuessInputProps> = ({ onSubmit }) => {
    const [guess, setGuess] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (guess.trim() !== '') {
            onSubmit(guess);
            setGuess('');
        }
    };

    return (
        <InputContainer>
            <form onSubmit={handleSubmit}>
                <InputField
                    type="text"
                    placeholder="Type your answer here..."
                    value={guess}
                    onChange={(e) => setGuess(e.target.value)}
                />
                <SubmitButton type="submit" disabled={guess.trim() === ''}>
                    Submit Guess
                </SubmitButton>
            </form>
        </InputContainer>
    );
};

export default GuessInput;
